import { TFunction } from "i18next";


export const toPascalCase = (str: string) => {
    return str.split(/[\s_]+/)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join('');

};


export const getTitle = (t: TFunction, tableName: string): string => {
    switch (tableName) {
        case "claimProfessionalType":
            return t("genericDic:newTitleClaimProfessionalType");

        case "functionalAreas":
            return t("genericDic:newTitleFunctionalAreas");

        default:
            return t("genericDic:newTitleGeneric", {
                tableName: t("genericDic:" + tableName).toLowerCase(),
            });
    }
};
